import { useState, useEffect } from 'react';
import axios from 'axios';
import { AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import './Dashboard.css';

export default function Analytics() {
  const [chart, setChart] = useState([]);
  const [range, setRange] = useState(30);

  useEffect(() => {
    axios.get(`/api/analytics/orders-chart?range=${range}`)
      .then(r => setChart(r.data))
      .catch(console.error);
  }, [range]);

  return (
    <div>
      <div className="page-header">
        <div><h1>Analytics</h1><p>Delivery performance over time</p></div>
        <div style={{ display:'flex', gap:8 }}>
          {[7, 14, 30, 90].map(r => (
            <button key={r} className={`btn btn--sm ${range === r ? 'btn--primary' : 'btn--ghost'}`}
              onClick={() => setRange(r)}>{r}d</button>
          ))}
        </div>
      </div>

      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">Orders Over Time (last {range} days)</div>
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={chart} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="ag" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#0057FF" stopOpacity={0.25}/>
                <stop offset="95%" stopColor="#0057FF" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F5" />
            <XAxis dataKey="date" tick={{ fontSize:11 }} />
            <YAxis tick={{ fontSize:11 }} />
            <Tooltip />
            <Area type="monotone" dataKey="count" stroke="#0057FF" strokeWidth={2} fill="url(#ag)" name="Orders" />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="card">
        <div className="card-title">Daily Order Volume (Bar)</div>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={chart} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F5" />
            <XAxis dataKey="date" tick={{ fontSize:11 }} />
            <YAxis tick={{ fontSize:11 }} />
            <Tooltip />
            <Bar dataKey="count" fill="#00D4FF" radius={[4,4,0,0]} name="Orders" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
